function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M242.5,484.6c-61.9,0-124-23.6-171.1-70.8C25.7,368,0.5,307.3,0.5,242.5S25.7,116.9,71.4,71.4 c94.5-94.3,248-94.3,342.4,0l0,0c94.3,94.6,94.3,248.3,0,342.5C366.7,461.1,304.5,484.6,242.5,484.6z"
}), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  id: "_x30_3_00000102527391476678882430000014751674365343938194_"
}, React.createElement("path", {
  fill: "#CCBA4F",
  d: "M410.4,410.6c-92.8,92.7-243.1,92.7-335.9,0c-92.7-92.7-92.7-243.1,0-335.9c92.7-92.7,243.1-92.7,335.9,0 C503.2,167.5,503.2,317.8,410.4,410.6z"
})), React.createElement("g", {
  id: "_x30_3_00000113352436633412887430000009413460469050170531_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M413.6,243.4c0,95.8-77.7,173.5-173.5,173.5c-95.8,0-173.5-77.7-173.5-173.5 C66.7,147.6,144.3,70,240.1,70C335.9,70,413.6,147.6,413.6,243.4z"
})), React.createElement("g", {
  id: "_x30_3_00000070100945373027196410000009526366880294003864_"
}, React.createElement("path", {
  fill: "#CCBA4F",
  d: "M240.1,411.1c-92.5,0-167.7-75.2-167.7-167.7c0-92.5,75.2-167.7,167.7-167.7 c92.5,0,167.7,75.2,167.7,167.7C407.8,335.9,332.6,411.1,240.1,411.1z M240.1,80.8c-89.7,0-162.7,73-162.7,162.7 c0,89.7,73,162.7,162.7,162.7s162.7-73,162.7-162.7C402.8,153.7,329.8,80.8,240.1,80.8z"
})))))), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M173.2,32.3l23.5-6.4l1.7,6.1l-16.7,4.5l1.7,6.3l14.7-4l1.7,6.1l-14.7,4l1.8,6.5l16.9-4.6l1.7,6.1l-23.7,6.4 L173.2,32.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M206.8,24.2l7.1-0.8l2.9,25.6l16-1.8l0.7,6.4l-23,2.6L206.8,24.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M237.8,21.6l7.1-0.1l0.5,32.3l-7.1,0.1L237.8,21.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M263,29.1l-9.8-1.1l0.7-6.5l26.6,3l-0.7,6.5l-9.8-1.1l-2.9,25.6l-7.1-0.8L263,29.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M289.6,26.3l23.5,6.4l-1.7,6.1l-16.7-4.6l-1.7,6.3l14.7,4l-1.7,6.1l-14.7-4l-1.8,6.5l16.9,4.6l-1.7,6.1 l-23.7-6.5L289.6,26.3z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#CCBA4F",
  d: "M104.1,247.9v-0.2c0-18.8,14.4-33.5,33.9-33.5c13.2,0,21.6,5.5,27.4,13.4L151.9,238 c-3.7-4.5-7.9-7.6-14.1-7.6c-9,0-15.4,7.7-15.4,17.1v0.2c0,9.7,6.4,17.2,15.4,17.2c6.7,0,10.7-3.1,14.6-7.8l13.4,9.6 c-6.1,8.4-14.3,14.6-28.5,14.6C118.9,281.2,104.1,267.2,104.1,247.9L104.1,247.9z"
}), React.createElement("polygon", {
  fill: "#CCBA4F",
  points: "171,215.3 189.3,215.3 189.3,239.6 212.5,239.6 212.5,215.3 230.4,215.3 230.4,280.2 212.5,280.2 212.5,255.5 188.9,255.5 188.9,280.2 171,280.2 171,215.3  "
}), React.createElement("polygon", {
  fill: "#CCBA4F",
  points: "171,215.3 189.3,215.3 189.3,239.6 212.5,239.6 212.5,215.3 230.4,215.3 230.4,280.2 212.5,280.2 212.5,255.5 188.9,255.5 188.9,280.2 171,280.2 171,215.3  "
}), React.createElement("path", {
  fill: "#CCBA4F",
  d: "M308.1,270.6l9.9-11.9c6.4,5.1,13.4,7.7,20.9,7.7c4.9,0,7.4-1.7,7.4-4.4v-0.3c0-2.8-2.1-4.2-11-6.3 c-13.8-3.1-24.4-7-24.4-20.3v-0.4c0-11.9,9.4-20.5,24.8-20.5c10.9,0,19.4,2.9,26.3,8.5l-8.9,12.5c-5.9-4.2-12.3-6.3-17.9-6.3 c-4.3,0-6.4,1.7-6.4,4.1v0.3c0,3,2.2,4.3,11.3,6.3c14.9,3.2,24.1,8.1,24.1,20.2v0.3c0,13.1-10.4,21-26,21 C326.8,281.2,316.1,277.6,308.1,270.6L308.1,270.6z"
}), React.createElement("path", {
  fill: "#CCBA4F",
  d: "M359.9,236.2L359.9,236.2c0-4.5,3.6-8.3,8.2-8.3c4.6,0,8.2,3.7,8.2,8.2v0c0,4.5-3.6,8.2-8.2,8.2 C363.4,244.3,359.9,240.6,359.9,236.2L359.9,236.2z M374.2,236.1L374.2,236.1c0-3.4-2.6-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3v0 c0,3.4,2.6,6.2,6.2,6.2C371.5,242.4,374.2,239.5,374.2,236.1L374.2,236.1z M364.6,232h3.7c2,0,3.4,0.9,3.4,2.6 c0,1.2-0.6,2-1.6,2.4l1.8,2.6h-3l-1.4-2H367v2h-2.4V232L364.6,232z M368.2,235.6c0.7,0,1-0.3,1-0.8c0-0.5-0.4-0.8-1-0.8H367v1.6 H368.2L368.2,235.6z"
}), React.createElement("path", {
  fill: "#CCBA4F",
  d: "M234.9,280.2h19l4.6-11.6h24.8l4.6,11.6h19.5L280,215.3h-17.7L234.9,280.2L234.9,280.2z M278.3,254.3h-14.6 l7.3-18.4L278.3,254.3L278.3,254.3z"
})));

var SvgChasElite = function SvgChasElite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_Elite",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485.3",
    style: {
      enableBackground: "new 0 0 485 485.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasElite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Elite.0df52b90.svg";
export { ForwardRef as ReactComponent };